import React, { ComponentType } from "react";
import { Header as DefaultHeader } from "../Header";
import { PrivateRoute } from "../PrivateRoute";
import { Route } from "react-router-dom";
import classes from "../../css/modules/layout.module.scss";
import { PageProps } from "../../types/PageProps";

type Props = {
  Header?: ComponentType;
  Component: ComponentType<PageProps>;
  path: string;
  exact?: boolean;
  secure?: boolean;
};

export function PageWrapper({ Header = DefaultHeader, Component, path, exact, secure = true }: Props) {
  const RouteComponent = secure ? PrivateRoute : Route;
  return (
    <>
      <Header />
      <div id="page-wrap" className={classes.pageRoot}>
        <RouteComponent path={path} exact={exact} component={Component} />
      </div>
    </>
  );
}
